import React, {FC} from 'react';
import {
  AnimatedNumber,
  CalculationResult,
  DisclaimerReferenceProps,
  EducationalInfo,
  getFormattedRangeResult,
  Result,
  ResultBar,
} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import {useTranslation} from '../use-translation';
import {useTenantConfiguration} from '../use-tenant-configuration';
import {EducationalInfoData} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';

interface OutputSectionProps {
  rangeKm: number;
  inView: boolean;
  disclaimer?: DisclaimerReferenceProps;
}

export const OutputSection: FC<OutputSectionProps> = ({
  rangeKm,
  disclaimer,
  inView,
}) => {
  const rangeTenantConfig = useTenantConfiguration();
  const translations = useTranslation();

  const range = getFormattedRangeResult(
    rangeTenantConfig,
    translations,
    rangeKm
  );

  const translationsEducationalInfo: EducationalInfoData = {
    educationalInfoContent: translations.resultSection.educationalInfoContent,
    educationalInfoLinkText:
      translations.resultSection.educationalInfoLinkText ||
      translations.global.educationalInfoLayer.FAQLink,
    educationalInfoInfoButtonLabel:
      translations.resultSection.educationalInfoInfoButtonLabel,
  };

  const resultRef = React.useRef<HTMLDivElement>(null);

  return (
    <section aria-label={translations.resultSection.ariaLabel} ref={resultRef}>
      <Result
        topLineTextPosition="left"
        topLine={translations.resultSection.simRangeLabel}
        disclaimer={disclaimer}
        educationalInfo={
          <EducationalInfo
            translations={translationsEducationalInfo}
            globalTranslations={translations.global}
            faqSectionTranslations={translations.faqSection}
            faqOrLink={rangeTenantConfig.resultSection}
            inverted={true}
          />
        }
      >
        <CalculationResult value={range} />
        <AnimatedNumber value={range} />
      </Result>
      {translations.resultSection.stickyResult && (
        <ResultBar
          inView={inView}
          headline={translations.resultSection.stickyResult.headline}
          value={range}
          ref={resultRef}
        />
      )}
    </section>
  );
};
